import RootState from 'ducks/RootState';
import { GlobalEmbedCodeOptions, PerAssetEmbedCodeOptions } from './types';

const getEmbedCodeOptionsState = (state: RootState) => state.embedCodeOptions;

export const getEmbedCodeGlobalOptions = (state: RootState) => getEmbedCodeOptionsState(state).globalOptions;

export const getEmbedCodeOptionsPerAsset = (state: RootState) => getEmbedCodeOptionsState(state).optionsPerAsset;

export const getGlobalOption = (option: GlobalEmbedCodeOptions) => (state: RootState) =>
  getEmbedCodeGlobalOptions(state)[option];

export const getPerAssetOption = (option: PerAssetEmbedCodeOptions) => (state: RootState) =>
  getEmbedCodeOptionsPerAsset(state)[option];
